var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1072_3694)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8607 11.7572C16.4944 12.1197 20 13.811 20 15.8427C20 18.1387 15.5228 20 10 20C4.47715 20 0 18.1387 0 15.8427C0 13.811 3.50574 12.1197 8.13958 11.7572L8.13954 15.0562C8.13954 16.0491 8.97249 16.8539 10 16.8539C11.0275 16.8539 11.8605 16.0491 11.8605 15.0562L11.8607 11.7572ZM10 0C10.3716 0 10.6753 0.280656 10.6965 0.634545L10.6977 0.674157L16.3282 3.39451C16.4431 3.45001 16.4896 3.585 16.4322 3.696C16.4097 3.73949 16.3732 3.77476 16.3282 3.7965L10.6977 6.51685V15.0562C10.6977 15.4285 10.3853 15.7303 10 15.7303C9.61469 15.7303 9.30233 15.4285 9.30233 15.0562V0.674157C9.30233 0.301831 9.61469 0 10 0Z",
    fill: "#94BDE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1072_3694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchIcon);
export default __webpack_public_path__ + "static/media/match-icon.ca69acf22355bbdfc6d7c7cf79db5b3f.svg";
export { ForwardRef as ReactComponent };